import { MessageDescriptor } from 'react-intl';

export const GENERATE_ROOMS_MESSAGE_TEXT: MessageDescriptor = {
    id: 'oe.generateRooms.generateRoomsMessageText',
    description: 'Info Message',
    defaultMessage: `Create & Assign Rooms will find all Meetings without a Room and assign them to a matching Room, if one exists.
    A Room matches a meeting if the Meeting Presenter Organization(s) match the Room Presenter(s),
    and the Meeting start and end times both fall within the start and end times of the Room.
    If there is no matching Room, a new Room will be created and assigned to the meeting.`
};
